import React from 'react';

import type { UserShape } from './ownership-models.ts';
import { PageOwnershipByLineWithContributorsDropdown } from './PageOwnershipByLineWithContributorsDropdown/index.ts';

type PageOwnershipBylineContentProps = {
	owner: UserShape | null;
	author: UserShape;
	contributorCountWithoutOwner: number;
	testId?: string;
	analyticsSource: string;
	generatedBy?: string | null;
	/** Optional callback fired after a successful owner change. */
	onOwnerChange?: (previousOwnerId: string, newOwnerId: string) => void;
	/**
	 * When false, the popup is rendered outside the DOM subtree of the trigger
	 * (via a portal), escaping any inherited colour scheme from a parent
	 * container (e.g. a folder header with a cover image). Defaults to the
	 * value driven by the a11y experiment when omitted.
	 */
	shouldRenderToParent?: boolean;
};

export const BadgeStylePageOwnershipByline = (
	props: PageOwnershipBylineContentProps,
): React.JSX.Element => {
	return <PageOwnershipByLineWithContributorsDropdown {...props} />;
};
